import { ca } from '@cian/analytics';

import { type TJsonQuery } from '@/packages/JsonQuery';

export function trackSuburbanShowSaveSearchClick(sc: TJsonQuery): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'saved_search',
    action: 'open',
    label: 'window',
    sc,
    useLastProducts: true,
  });
}
